import React, { useState, useEffect } from 'react';
import { Col, Row, Form, FormGroup, Input, Button, Spinner, CardBody, CardHeader, Label,Card } from 'reactstrap';
import axios from 'axios';
import toast, { Toaster } from 'react-hot-toast';
import './CatchmentContext.css'; import { apiGet, apiPost } from "../Utilities/Hooks/apiWrapper";

const OtherInfo = ({ SectionObj }) => {
    const roleName = localStorage.getItem("roleName");
    const saveRightsForNonItemFieldsAndTables = localStorage.getItem("saveRightsForNonItemFieldsAndTables");
    const [saving, setSaving] = useState('');
    const [memberships, setMemberships] = useState('');
    const [contaminantPriorities, setContaminantPriorities] = useState('');
    const [description, setDescription] = useState('');
    const [farmId] = useState(localStorage.getItem("defaultFarmId"));
    const [userId] = useState(localStorage.getItem("loggedInUserId"));

    useEffect(() => {
        getOtherInfo();
        
    }, [])

    const getOtherInfo = async () => {
        try {
            const response = await apiGet('/api/catchmentContext/getOtherInfo/', {
                params: {
                    farmId: farmId
                }
            });

            setMemberships(response?.data?.memberships);
            setContaminantPriorities(response?.data?.contaminantPriorities);
            setDescription(response?.data?.description);

        } catch (error) {
            if (!error?.response) {
                toast.error(error.response?.status + ": " + error.message, { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
            } else {
                toast.error("No server response", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
            }
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault()

        setSaving(true);

        try {
            const response = await apiPost(
                '/api/catchmentContext/saveOtherInfo/',
                JSON.stringify(
                    {
                        memberships, contaminantPriorities, description, farmId, userId
                    }), {
                headers: { 'Content-Type': 'application/json' }
            });

            setTimeout(() => {
                setSaving(false);
            }, 1000)

            console.log(response);

            toast.success("Other Catchment Info Saved!", { duration: 3000, style: { border: '1px solid #B6D137', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#B6D137', secondary: '#FFFAEE', } });

        } catch (err) {
            setTimeout(() => {
                setSaving(false);
            }, 1000)

            if (!err?.response) {
                toast.error("No server response!", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
            } else if (err.response?.status === 400) {
                toast.error("Saving Other Catchment Info Failed!", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
            } else {
                toast.error("Saving Other Catchment Info Failed!", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
            }
        }
    }

    return (
        <>
            <Toaster position="top-center" containerStyle={{ top: '50%' }} />
            <Col>
                <Card>
                    <CardHeader className="card-header-dark">
                        <h5>Sub Catchment Membership and Information</h5>
                    </CardHeader>
                    <CardBody>
                        <Form onSubmit={handleSubmit}>
                            <Row>
                                <Col>
                                    <Row>
                                        <Col sm="6">
                                            <FormGroup>
                                                <Label for="memberships">
                                                    Subcatchment Membership(s)
                                                </Label>
                                                <Input
                                                    id="memberships"
                                                    name="text"
                                                    placeholder=""
                                                    type="text"
                                                    value={memberships}
                                                    onChange={(e) => setMemberships(e.target.value)}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col sm="6">
                                            <FormGroup>
                                                <Label for="contaminantPriorities">
                                                    Subcatchment Contaminant Priorities
                                                </Label>
                                                <Input
                                                    id="contaminantPriorities"
                                                    name="text"
                                                    placeholder=""
                                                    type="text"
                                                    value={contaminantPriorities}
                                                    onChange={(e) => setContaminantPriorities(e.target.value)}
                                                />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <FormGroup>
                                            <Col>
                                                <Input
                                                    id="description"
                                                    name="description"
                                                    type="textarea"
                                                    value={description}
                                                    onChange={(e) => setDescription(e.target.value)}
                                                />
                                            </Col>
                                        </FormGroup>
                                    </Row>
                                    <br />
                                </Col>
                            </Row>
                            {(roleName == 'Admin' || saveRightsForNonItemFieldsAndTables == 'true') &&
                                <>
                                    {saving ?
                                        <Button style={{ float: "right" }}
                                            color="success"
                                            disabled
                                        >
                                            <Row>
                                                <Col sm="8">
                                                    <span>
                                                        {' '}Saving
                                                    </span>
                                                </Col>
                                                <Col sm="4">
                                                    <Spinner size="sm">
                                                        Saving...
                                                    </Spinner>
                                                </Col>
                                            </Row>
                                        </Button>
                                        :
                                        <Button style={{ float: "right" }} color="success" size="sm">
                                            Save
                                        </Button>
                                    }
                                </>
                            }
                        </Form>
                    </CardBody>
                </Card>
            </Col>
        </>
    )
}

export default OtherInfo